<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4">
          <!-- Progress -->
          <div class="progress">
            <div class="progress-bar" role="progressbar" style="width: 66%"
              aria-valuenow="66" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <div v-html="data.consentpath.consentPathText"></div>
          <!-- 1177 -->
          <div class="card text-center">
            <div class="form-check text-left">
              <input class="form-check-input" type="radio" name="radio_choice"
                id="radio_1177" value="radio_1177" v-model="path">
              <label class="form-check-label" for="radio_1177" v-html="data.consentpath.firstChoiceText"></label>
            </div>
            <div class="form-check text-left">
              <select class="form-control" :disabled="path === 'radio_calls_sms'"
                @change="drugs.second_choice_drug = null" v-model="drugs.first_choice_drug">
                <option :value="null">{{ data.misc.chooseMedicationLabel }}</option>
                <option v-for="(medValue, medLabel) in data.misc.medicationList"
                  :disabled="medLabel.startsWith('—')" :value="medValue" v-bind:key="medValue">
                  {{ medLabel }}
                </option>
              </select>
            </div>
          </div>
          <!-- Calls/SMS from nurse -->
          <div class="card text-center">
            <div class="form-check text-left">
              <input class="form-check-input" type="radio" name="radio_choice"
                id="radio_calls_sms" value="radio_calls_sms" v-model="path">
              <label class="form-check-label" for="radio_calls_sms" v-html="data.consentpath.secondChoiceText"></label>
            </div>
            <div class="form-check text-left">
              <select class="form-control" :disabled="path === 'radio_1177'"
                @change="drugs.first_choice_drug = null" v-model="drugs.second_choice_drug">
                <option :value="null">{{ data.misc.chooseMedicationLabel }}</option>
                <option v-for="(medValue, medLabel) in data.misc.medicationList"
                  :disabled="medLabel.startsWith('—')" :value="medValue" v-bind:key="medValue">
                  {{ medLabel }}
                </option>
              </select>
            </div>
            <div class="form-check text-left">
              <div class="clearfix--min"></div>
              <label for="phone" v-html="data.consentpath.phoneNumberLabel"></label>
              <div class="input-group sm-3">
                <input
                  inputmode="numeric"
                  placeholder="07X XXX XX XX"
                  autocomplete="off"
                  ref="phone"
                  class="form-control phone-number-input"
                  type="text"
                  name="phoneNumber"
                  v-model="phoneNumber"
                  :maxlength="12"
                  :disabled="path === 'radio_1177'"
                  @input="enforceNumbers()"
                />
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-consent btn-primary btn-lg btn-block"
            @click="giveConsentPath()"
            :disabled="!firstChoiceValid && !secondChoiceValid">
            OK
          </button>
          <div class="clearfix"></div>
          <small class="text-muted" v-html="data.consent.consentDisclaimer"></small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { showDelayText } from '../plugins/delayhandler'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'consentpath',
  components: {},
  data () {
    return {
      data: null,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      phoneNumber: '',
      countryCode: '+46',
      drugs: {
        first_choice_drug: null,
        second_choice_drug: null
      },
      path: null
    }
  },
  methods: {
    enterKeyHandler (e) {
      if (e.key === 'Enter' && this.path !== null) {
        this.giveConsentPath()
      }
    },
    giveConsentPath () {
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      const serviceChoice = this.path === 'radio_1177'
        ? 1 : 2
      const nmbr = (this.phoneNumber.length < 1 || this.path === 'radio_1177')
        ? '' : (this.countryCode + this.phoneNumber.replace(/^0+/, ''))
      const drug = this.drugs.first_choice_drug !== null
        ? this.drugs.first_choice_drug : this.drugs.second_choice_drug
      axios.postConsentPath(config.serviceUri, serviceChoice, drug, nmbr).then((response) => {
        if (response) {
          loader.hide()
          sessionStorage.setItem('path', this.path)
          if (nmbr && nmbr.length > 0) {
            sessionStorage.setItem('nmbr', nmbr)
          }
          if (this.path === 'radio_calls_sms') this.$router.push('/entercode')
          else this.$router.push('/nextstep')
        }
      }, (error) => {
        if (error.response) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        }
      })
    },
    enforceNumbers () {
      this.phoneNumber = this.phoneNumber.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    }
  },
  created () {
    window.addEventListener('keydown', this.enterKeyHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.enterKeyHandler)
  },
  computed: {
    isPhoneNumberValid () {
      if (this.phoneNumber && this.phoneNumber.length > 8) {
        return true
      } else {
        return false
      }
    },
    firstChoiceValid () {
      return this.path && this.path === 'radio_1177' && (this.drugs.first_choice_drug !== null && this.drugs.second_choice_drug === null)
    },
    secondChoiceValid () {
      return this.path && this.path === 'radio_calls_sms' &&
        (this.drugs.second_choice_drug !== null && this.drugs.first_choice_drug === null) && this.isPhoneNumberValid
    }
  },
  watch: {
    path (p) {
      if (p === 'radio_1177') {
        this.phoneNumber = ''
        this.drugs.second_choice_drug = null
      } else {
        this.drugs.first_choice_drug = null
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          consentpath(locale: ` + sessionStorage.getItem('language') + `) {
            consentPathText
            firstChoiceText
            secondChoiceText
            phoneNumberLabel
          }
          consent(locale: ` + sessionStorage.getItem('language') + `) {
            consentDisclaimer
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            consentApproveBtn
            medicationList
            chooseMedicationLabel
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
button:disabled {
  opacity: 0.3;
}
.card {
  min-height: 222px;
  background: #eaecf07e !important;
}
.btn-consent {
  background: #03206073;
}
.btn-consent:hover:after {
  content: ' ✔';
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .card {
    margin-top: 2vh;
  }
  .container {
    margin-bottom: -6.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConsentPath.vue